'use client';

import { useTranslations } from "next-intl";
import { Button } from "../ui/button";
import Link from "next/link";

const PriceListButton = () => {
  const t = useTranslations('common');

  return (
    <Button
      className="bg-brand text-white hover:bg-accent-blue hover:cursor-pointer disabled:cursor-not-allowed"
      asChild
    >
      <Link href="/prices">
        {t('button_price_list')}
      </Link>
    </Button>
  );
}

export default PriceListButton;
